// importing actions
import {
  LOAD_DASHBOARD_COUNT,
  TICKET,
  FETCH_AGENTS,
  FETCH_HOSPITALS,
  FETCH_PIPELINES,
  FETCH_VENDORS,
  PREMIUM_LIST,
  ADD_AGENT,
  ADD_DISPATCH,
  RIDER_DETAILS,
  CYLINDER_LIST,
  CYLINDER_SERIES,
  CYLINDER_SIZE,
  PLANTS_LIST,
  CYLINDER_DETAILS,
  FETCH_NOTIFICATIONS,
  NERVE_CLAIMS,
  CRADLE_REQUEST,
  CRADLE_UPDATE,
  INCIDENT_REPORT,
  INCIDENT_REPORT_POST,
  NOTIFY_NERVE,
  NOTIFY_NERVE_POST,
  DELETE_NERVE_POST,
  SHOW_ALL_PO,
  CREATE_COHORTS,
  SHOW_COHORT,
  SHOW_COHORT_LIST,
  SEND_BULK_MESSAGE,
  ADD_HOSPITALS_COHORT,
  GET_HOSPITAL_CORHOT,
  GET_ALL_QUOTATION,
  SINGLE_QUOTATION,
  POST_QUOTATION,
} from "../../types";
import { SEND_NERVE_CLAIM } from "../services/admin.endpoints";

// state
const INITIAL_STATE = {
  dashboardCounts: {},
  ticket: {},
  agents: [],
  hospitals: [],
  pipelines: [],
  vendors: [],
  premiumList: [],
  addAgent: {},
  addDispatch: {},
  dispatchRecord: {},
  cylinders: [],
  series: [],
  size: [],
  plants: [],
  cylinderDetails: [],
  notifications: [],
  nerveClaims: [],
  sendNerveClaims: [],
  cradleRequest: [],
  cradleUpdate: [],
  incidentReport: [],
  incidentReportPost: [],
  notifyNerve: [],
  notifyNervePost: [],
  deleteNervePost: [],
  showPo: [],
  showCohort: [],
  createCohort: [],
  showCohortList: [],
  sendCohort: [],
  addHopital: [],
  allHospitalCohort: [],
  seeQuotation: [],
  singleQuotation: [],
  sendQuotation: [],
  currentPage: 1,
  itemsPerPage: 10,
};

// Redux reducer function
const adminReducer = (state = INITIAL_STATE, action) => {
  // Destructuring action
  const { type, payload, page, itemsPerPage } = action;

  switch (type) {
    case LOAD_DASHBOARD_COUNT:
      return {
        ...state,
        dashboardCounts: payload,
      };

    case SHOW_ALL_PO: {
      return {
        ...state,
        showPo: payload || [],
        currentPage: page,
        itemsPerPage: itemsPerPage,
      };
    }

    case GET_HOSPITAL_CORHOT: {
      return {
        ...state,
        allHospitalCohort: payload,
      };
    }
    case SHOW_COHORT: {
      return {
        ...state,
        showCohort: payload,
      };
    }
    case CREATE_COHORTS: {
      return {
        ...state,
        createCohort: payload,
      };
    }

    case SHOW_COHORT_LIST: {
      return {
        ...state,
        showCohortList: payload,
      };
    }

    case ADD_HOSPITALS_COHORT: {
      return {
        ...state,
        addHopital: payload,
      };
    }

    case SEND_BULK_MESSAGE: {
      return {
        ...state,
        sendCohort: payload,
      };
    }
    case TICKET:
      return {
        ...state,
        ticket: payload,
      };

    case FETCH_AGENTS:
      return {
        ...state,
        agents: payload,
      };

    case FETCH_HOSPITALS:
      return {
        ...state,
        hospitals: payload,
      };

    case FETCH_PIPELINES:
      return {
        ...state,
        pipelines: payload,
      };

    case FETCH_VENDORS:
      return {
        ...state,
        vendors: payload,
      };

    case PREMIUM_LIST:
      return {
        ...state,
        premiumList: payload,
      };
    case ADD_AGENT:
      return {
        ...state,
        addAgent: payload,
      };
    case ADD_DISPATCH:
      return {
        ...state,
        addDispatch: payload,
      };
    case RIDER_DETAILS:
      return {
        ...state,
        dispatchRecord: payload,
      };
    case CYLINDER_LIST:
      return {
        ...state,
        cylinders: payload,
      };
    case CYLINDER_SERIES:
      return {
        ...state,
        series: payload,
      };
    case CYLINDER_SIZE:
      return {
        ...state,
        size: payload,
      };
    case PLANTS_LIST:
      return {
        ...state,
        plants: payload,
      };
    case CYLINDER_DETAILS:
      return {
        ...state,
        cylinderDetails: payload,
      };
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload,
      };

    case NERVE_CLAIMS:
      return {
        ...state,
        nerveClaims: payload,
      };
    case SEND_NERVE_CLAIM:
      return {
        ...state,
        sendNerveClaims: payload,
      };

    case CRADLE_REQUEST:
      return {
        ...state,
        cradleRequest: payload,
      };

    case CRADLE_UPDATE:
      return {
        ...state,
        cradleUpdate: payload,
      };

    case INCIDENT_REPORT:
      return {
        ...state,
        incidentReport: payload,
      };

    case INCIDENT_REPORT_POST:
      return {
        ...state,
        incidentReportPost: payload,
      };

    case NOTIFY_NERVE:
      return {
        ...state,
        notifyNerve: payload,
      };
    case NOTIFY_NERVE_POST:
      return {
        ...state,
        notifyNervePost: payload,
      };
    case DELETE_NERVE_POST:
      return {
        ...state,
        deleteNervePost: payload,
      };

    case GET_ALL_QUOTATION:
      return {
        ...state,
        seeQuotation: payload,
      };
    case SINGLE_QUOTATION:
      return {
        ...state,
        singleQuotation: payload,
      };
    case POST_QUOTATION:
      return {
        ...state,
        sendQuotation: payload,
      };
    default:
      return state;
  }
};

export default adminReducer;
